/**
 * @template T
 * @param {(t: T) => any} f
 * @returns {(a: T, b: T) => -1 | 0 | 1}
 */
export function cmpByKey(f) {
	return (a, b) => {
		const aKey = f(a);
		const bKey = f(b);
		if (aKey === bKey) {
			return 0;
		} else if (aKey < bKey) {
			return -1;
		} else {
			return 1;
		}
	};
}

/**
 * @template T
 * @param {(a: T, b: T) => -1 | 0 | 1} f
 * @returns {(a: T, b: T) => -1 | 0 | 1}
 */
export function cmpReverse(f) {
	return (a, b) => {
		const res = f(a, b);
		if (res === 0) {
			return 0;
		// eslint-disable-next-line yoda
		} else if (0 < res) {
			return -1;
		} else {
			return 1;
		}
	};
}

/**
 * @template T
 * @param {...(a: T, b: T) => -1 | 0 | 1} fs
 * @returns {(a: T, b: T) => -1 | 0 | 1}
 */
export function combineCmps(...fs) {
	return (a, b) => {
		for (const f of fs) {
			const res = f(a, b);
			if (res !== 0) {
				return res;
			}
		}
		return 0;
	};
}
